import { h } from 'preact';
import React, { Component } from 'react';
import { makeText, isActionAllowed } from '../../../util';

export default class Switch extends Component {
  state = {
    isPurModelChecked: false,
    toggleDisplay: true,
  };

  toggle = (shouldCheck) => {
    const { child, value, vendors, consentType } = this.props;
    const isChecked = shouldCheck !== undefined ? shouldCheck : !this.props.checked;
    if (child === 'purposes' || child === 'features') {
      this.props.toggle(value._id, child, isChecked, vendors, this.props.legInt);
      this.setState({ checked: isChecked })
    } else if (child === 'vendors') {
      // 'active' refers to 'consent'
      this.props.toggle(value.vendorId, isChecked, consentType === 'consent' ? 'active' : consentType);
      this.setState({ checked: isChecked })
    } else if (child === 'stacks') {
      this.props.toggle(value._id, isChecked);
      this.setState({ checked: isChecked })
    }
  }

  componentDidMount = () => {
    if (this.props.usePurModel && this.props.consentType !== 'legInt' && this.props.consentType !== 'all') {
      this.toggle(true);
    };
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.usePurModel !== prevProps.usePurModel) {
      this.setState({ isPurModelChecked: this.props.usePurModel, toggleDisplay: !this.state.toggleDisplay }, () => {
        if (this.props.value.legInt !== null) {
          this.toggle(this.state.isPurModelChecked);
        };
      });
    };
  };

  render() {
    const {
      color,
      offColor,
      neutralColor,
      checked,
      locked,
      value: { name: ariaLabel },
      tabbable,
      partialConsent,
      dev,
      settings,
      language,
    } = this.props;
    const backgroundColor = checked
      ? (partialConsent ? neutralColor : color)
      : offColor;

    const toggleOnText = makeText(Boolean(dev), settings, 'toggleOnText', language);
    const toggleOffText = makeText(Boolean(dev), settings, 'toggleOffText', language);

    const hasText = toggleOnText || toggleOffText;
    const hasTextClass = hasText ? ' has-text' : '';

    const basicClassName = checked ? ('pm-switch checked' + hasTextClass) : ('pm-switch' + hasTextClass);
    const vendorLegInt = this.props.child === 'vendors' && this.props.value.legInt !== null && this.props.consentType === 'legInt';

    const isToggleOn = vendorLegInt || (this.props.usePurModel && this.props.consentType === 'legInt') || !this.props.usePurModel || this.state.toggleDisplay && !this.props.usePurModel ? 'inline-flex' : 'none';
    return (
      <button
        tabIndex="0"
        type="button"
        role="switch"
        aria-checked={checked ? "true" : "false"}
        className={(locked ? basicClassName + ' locked' : basicClassName) + (partialConsent ? ' partial' : '')}
        onClick={(e) => {
          e.stopPropagation();
          this.toggle(!checked)
        }}
        style={{ display: isToggleOn }}
      >
        <span
          className={checked ? 'slider round is-checked' : 'slider round'}
          style={{ backgroundColor }}
        >
          {partialConsent ? null : (checked ? toggleOnText : toggleOffText)}
        </span>
      </button>
    );
  }
}
